var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timelineSegment",class:{ active: _vm.isActive },style:({ width: _vm.spanWidth }),on:{"click":function($event){$event.stopPropagation();return _vm.jumpToYear($event)}}},[_c('p',{ref:"text",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.endYear)+" to "+_vm._s(_vm.startYear))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f62ee72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Segment.vue
// module id = null
// module chunks = 